import script from "./xt_project_card.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_project_card.vue?vue&type=script&setup=true&lang=js"

import "./xt_project_card.vue?vue&type=style&index=0&id=19b10e99&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b10e99"]])

export default __exports__